import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=7bace86b"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bace86b')) {
      api.createRecord('7bace86b', component.options)
    } else {
      api.reload('7bace86b', component.options)
    }
    module.hot.accept("./Payment.vue?vue&type=template&id=7bace86b", function () {
      api.rerender('7bace86b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Payment.vue"
export default component.exports